/**
 * Pseudo locale.
 *
 * Mechanically expands every string to about 1.4x with accented characters.
 * Turning it on is how you find out whether the layout actually survives Thai,
 * instead of claiming it does in a document. Placeholders like {name} are
 * preserved verbatim so an expanded string still interpolates.
 */

const ACCENTS: Record<string, string> = {
  a: 'á', b: 'ƀ', c: 'ç', d: 'ð', e: 'é', f: 'ƒ', g: 'ĝ', h: 'ĥ', i: 'í',
  j: 'ĵ', k: 'ķ', l: 'ĺ', m: 'ɱ', n: 'ñ', o: 'ó', p: 'ƥ', q: 'ɋ', r: 'ŕ',
  s: 'š', t: 'ţ', u: 'ú', v: 'ṽ', w: 'ŵ', x: 'ẋ', y: 'ý', z: 'ž',
  A: 'Á', B: 'Ɓ', C: 'Ç', D: 'Ð', E: 'É', F: 'Ƒ', G: 'Ĝ', H: 'Ĥ', I: 'Í',
  J: 'Ĵ', K: 'Ķ', L: 'Ĺ', M: 'Ṁ', N: 'Ñ', O: 'Ó', P: 'Ƥ', Q: 'Ɋ', R: 'Ŕ',
  S: 'Š', T: 'Ţ', U: 'Ú', V: 'Ṽ', W: 'Ŵ', X: 'Ẋ', Y: 'Ý', Z: 'Ž',
};

const PAD = 'șŧɍēŧčĥ';

export function pseudo(input: string): string {
  const parts = input.split(/(\{[^}]+\})/g);
  const accented = parts
    .map((part) => {
      if (part.startsWith('{') && part.endsWith('}')) return part;
      return part.replace(/[a-zA-Z]/g, (ch) => ACCENTS[ch] ?? ch);
    })
    .join('');

  const target = Math.ceil(input.length * 0.4);
  let pad = '';
  while (pad.length < target) pad += PAD;

  return `[${accented} ${pad.slice(0, target)}]`;
}
